import { positionService } from '@/services/api/position.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { positionModel } from '@/models/api/position.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const POSITION_MODULE = "api/position";

// ACTIONS
export const GET_ALL_POSITION = 'getAllPosition';
export const CREATE_POSITION = 'createPosition';
export const GET_POSITION = 'getPosition';
export const UPDATE_POSITION = 'updatePosition';
export const UPDATE_POSITION_STATUS = 'updatePositionStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_POSITION_SUCCESS = "allPositionSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_POSITION_SUCCESS = "getPositionSuccess";

export const actions = {
    [GET_ALL_POSITION]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        positionService
            .getAll(filter)
            .then((result) => {
                commit(ALL_POSITION_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_POSITION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return positionService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_POSITION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_POSITION]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return positionService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_POSITION_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_POSITION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return positionService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_POSITION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_POSITION_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return positionService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_POSITION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_POSITION_SUCCESS](state, {data}) {
        let positionList = data.data || [];
        state.list.data = positionList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = positionList.map(item => positionModel(item));
        }
    },
    [GET_POSITION_SUCCESS](state, data) {
        state.details = positionModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
